import { CustomSelectOption } from '../interfaces/custom-select-option';
import { MedicalCondition } from './medical-condition';

export interface DependentMedicalConditionInterface {
  medical_condition: CustomSelectOption;
  date_diagnosed?: string;
  treatment?: string;
}


export class DependentMedicalCondition {
  dependent_uuid!: string;
  medical_condition_uuid!: string;
  date_diagnosed!: number;
  treatment?: string;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  medical_condition?: MedicalCondition;

  constructor(data: any) {
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;
    this.dependent_uuid = data.dependent_uuid;
    this.medical_condition_uuid = data.medical_condition_uuid;
    this.date_diagnosed = data.date_diagnosed;
    this.treatment = data.treatment;
    this.uuid = data.uuid;

    if (data.medical_condition) {
      this.medical_condition = new MedicalCondition(data.medical_condition);
    }
  }
}
